import { gql } from '@apollo/client';

const UPDATE_USER_EMAIL_PREFERENCES = gql`
  mutation UpdateUserEmailPreferences($data: UserEmailPreferencesInput) {
    updateUserEmailPreferences(data: $data)
  }
`;

export default UPDATE_USER_EMAIL_PREFERENCES;
